export default __webpack_public_path__ + "static/hero-pescatarian-44f4958d9b63d77c52fbdaa1b10ad49c.jpg";